export default "__VITE_ASSET__1bd024cc__"